import { ERROR_MESSAGE } from './constantTypes';

export const validatePassword = (password: string) => {
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%#?&"'()\*\+,\-./:;<=>?@[\]\\^_`{|}~÷€£¥•₹×¿¡°])[A-Za-z\d@$!%*#?&"'()\*\+,\-./:;<=>?@[\]\\^_`{|}~÷€£¥•₹×¿¡°]{8,}$/;

  const errMsg = !passwordRegex.test(password)
    ? ERROR_MESSAGE.passwordErrormsg
    : '';
  return errMsg;
};

export const validateConfirmPassword = (
  cpassword: string,
  password: string
) => {
  const errMsg =
    cpassword !== password ? ERROR_MESSAGE.confPasswordErrormsg : '';
  return errMsg;
};

export const validateName = (name: string) => {
  const nameRegex = /^[a-z][a-z\s]*$/i;
  const errMsg = !nameRegex.test(name) ? ERROR_MESSAGE.nameErrormsg : '';
  return errMsg;
};

export const validateLicenseNumber = (number: string) => {
  const numericOnlyRegex = /^[0-9]+$/;
  const errMsg = !numericOnlyRegex.test(number)
    ? ERROR_MESSAGE.numberErrormsg
    : '';
  return errMsg;
};

export const validateEmail = (email: string) => {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const errMsg = !emailRegex.test(email) ? ERROR_MESSAGE.emailErrorMsg : '';
  return errMsg;
};

export const validateMobile = (mobile: string, code?: string) => {
  const mobileRegexInd = /^(?:(?:\+91)|(?:0))?[6789]\d{9}$/;
  const mobileRegexUS =
    /^(?:\+1)?(?:\(\d{3}\)|\d{3})(?:-|\s)?\d{3}(?:-|\s)?\d{4}$/;
  let regex = mobileRegexUS;
  if (code) {
    switch (code) {
      case '+91':
        regex = mobileRegexInd;
        break;
      case '+1':
        regex = mobileRegexUS;
        break;
    }
  } else if (mobile.length > 4) {
    regex = mobile.startsWith('+91') ? mobileRegexInd : mobileRegexUS;
  }
  const errMsg = !regex.test(mobile) ? ERROR_MESSAGE.mobileErrorMsg : '';
  return errMsg;
};

export const validateZipcode = (code) => {
  if (code?.length <= 10) {
    return true;
  }
  return false;
};
